import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "w-full flex flex-col" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-left font-bold text-2xl" }, "Endereço"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-left text-sm text-gray-500" }, " Preenche seu CEP para buscar o endereço automáticamente ")
], -1)
const _hoisted_2 = { class: "flex flex-col w-full gap-2" }

import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useDoctorRegistryStore } from '@/pinia-store/useDoctorRegistryStore'
import ufs from '@/config/StatesFromBR'
import { rules } from '@/utils/rules'
import { SearchCep } from '@/Network/Services/CepService'


export default /*#__PURE__*/_defineComponent({
  __name: 'Address',
  setup(__props) {

const doctorRegistryStore = useDoctorRegistryStore()
const { addressForm, addressFormRef } = storeToRefs(doctorRegistryStore)

const isLoadingCep = ref(false)
const cepResponse = ref<string | null>(null)
const searchCep = async () => {
  cepResponse.value = ''
  const cep = addressForm.value.cep.replace('-', '')
  if (cep.length !== 8) return
  try {
    isLoadingCep.value = true
    const data = await SearchCep(cep)
    addressForm.value.street = data.logradouro
    addressForm.value.district = data.bairro
    addressForm.value.city = data.localidade
    addressForm.value.state = data.uf
  } catch (error) {
    cepResponse.value = 'CEP não encontrado'
  } finally {
    isLoadingCep.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_form = _resolveComponent("v-form")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_v_form, {
    ref_key: "addressFormRef",
    ref: addressFormRef,
    id: "formDoctorSignUpPesonalData",
    class: "w-full flex gap-7 items-center flex-col rounded overflow-hidden mt-5 mb-4"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _withDirectives((_openBlock(), _createBlock(_component_v_text_field, {
          modelValue: _unref(addressForm).cep,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((_unref(addressForm).cep) = $event)),
            searchCep
          ],
          label: "* Cep",
          class: "w-full",
          color: "primary20",
          variant: "outlined",
          error: !!cepResponse.value,
          rules: [_unref(rules).required],
          "validate-on": "lazy input"
        }, {
          loader: _withCtx(() => [
            _createVNode(_component_v_progress_linear, {
              active: isLoadingCep.value,
              color: "primary",
              height: "7",
              indeterminate: ""
            }, null, 8, ["active"])
          ]),
          _: 1
        }, 8, ["modelValue", "error", "rules"])), [
          [_directive_maska, '#####-###']
        ]),
        _createVNode(_component_v_text_field, {
          modelValue: _unref(addressForm).street,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(addressForm).street) = $event)),
          label: "* Rua",
          class: "w-full",
          color: "primary20",
          variant: "outlined"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_v_text_field, {
          modelValue: _unref(addressForm).number,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(addressForm).number) = $event)),
          label: "* Número",
          class: "w-full",
          variant: "outlined",
          color: "primary20"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_v_text_field, {
          modelValue: _unref(addressForm).complement,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(addressForm).complement) = $event)),
          label: "Complemento",
          class: "w-full",
          variant: "outlined",
          color: "primary20"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_v_text_field, {
          modelValue: _unref(addressForm).district,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(addressForm).district) = $event)),
          label: "Bairro",
          class: "w-full",
          variant: "outlined",
          color: "primary20"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_v_text_field, {
          modelValue: _unref(addressForm).city,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(addressForm).city) = $event)),
          label: "Cidade",
          class: "w-full",
          color: "primary20",
          variant: "outlined"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_v_autocomplete, {
          modelValue: _unref(addressForm).state,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(addressForm).state) = $event)),
          label: "* Estado",
          color: "primary",
          variant: "outlined",
          items: _unref(ufs),
          rules: [_unref(rules).required, _unref(rules).uf, _unref(rules).ufLen]
        }, {
          item: _withCtx(({ props, item }) => [
            _createVNode(_component_v_list_item, _mergeProps(props, {
              title: item?.raw?.value,
              subtitle: item?.raw?.title
            }), null, 16, ["title", "subtitle"])
          ]),
          _: 1
        }, 8, ["modelValue", "items", "rules"])
      ])
    ]),
    _: 1
  }, 512))
}
}

})